/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_u3_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three minutes is long enough to smooth out a fast start or an early stumble, but short enough to stay comfortable to take. Most typing certificates, school programs, and job screenings report a 3-minute WPM for that reason — it balances accuracy of measurement against test length.`)
};

const es_typing_u3_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tres minutos es lo bastante largo para suavizar un arranque rápido o un tropiezo temprano, pero lo bastante corto para que resulte cómodo de hacer. Por eso la mayoría de certificados de mecanografía, programas escolares y procesos de selección reportan el WPM de 3 minutos — equilibra la precisión de la medición con la duración del test.`)
};

const de_typing_u3_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drei Minuten sind lang genug, um einen schnellen Start oder einen frühen Ausrutscher auszugleichen, aber kurz genug, um angenehm durchführbar zu bleiben. Die meisten Tippzertifikate, Schulprogramme und Einstellungstests geben deshalb einen 3-Minuten-WPM-Wert an — er balanciert Messgenauigkeit und Testlänge aus.`)
};

const nl_typing_u3_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drie minuten is lang genoeg om een snelle start of een vroege misstap uit te vlakken, maar kort genoeg om prettig te blijven om af te leggen. De meeste typecertificaten, schoolprogramma's en sollicitatietests rapporteren daarom een WPM over 3 minuten — het balanceert meetnauwkeurigheid tegen testduur.`)
};

const fr_typing_u3_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trois minutes suffisent pour lisser un départ rapide ou un faux départ, tout en restant assez court pour rester confortable à faire. La plupart des certificats de frappe, programmes scolaires et sélections d'emploi indiquent un WPM sur 3 minutes pour cette raison — cela équilibre précision de mesure et durée du test.`)
};

const it_typing_u3_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tre minuti sono sufficienti per attenuare un avvio veloce o un inciampo iniziale, ma abbastanza brevi da rimanere comodi da svolgere. Per questo la maggior parte dei certificati di digitazione, dei programmi scolastici e delle selezioni di lavoro riporta un WPM da 3 minuti — bilancia l'accuratezza della misurazione con la durata del test.`)
};

const pt_br2_typing_u3_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Três minutos é tempo suficiente para suavizar um início rápido ou um tropeço inicial, mas curto o bastante para continuar confortável de fazer. Por isso, a maioria dos certificados de digitação, programas escolares e processos seletivos reporta o WPM de 3 minutos — ele equilibra a precisão da medição com a duração do teste.`)
};

const pt_typing_u3_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Três minutos é suficientemente longo para suavizar um arranque rápido ou um tropeço inicial, mas suficientemente curto para se manter confortável de fazer. A maioria dos certificados de escrita, programas escolares e processos de seleção reportam um WPM de 3 minutos por essa razão — equilibra a precisão da medição com a duração do teste.`)
};

const ja_typing_u3_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3分間は、好調な滑り出しや序盤のつまずきを均すのに十分な長さでありながら、無理なく受けられる短さでもあります。多くのタイピング資格や学校のプログラム、採用選考で3分間のWPMが報告されているのはこのためで、測定の正確さとテスト時間のバランスが取れています。`)
};

const zh_typing_u3_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`三分钟足够长，可以平滑开局过快或早期失误的影响，但又足够短，让人测试起来仍感舒适。因此大多数打字证书、学校项目和求职筛选都采用3分钟WPM作为标准 — 它在测量准确性与测试时长之间取得了平衡。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_u3_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_u3_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_u3_faq3_a", locale)
	if (locale === "en") return en_typing_u3_faq3_a(inputs)
	if (locale === "es") return es_typing_u3_faq3_a(inputs)
	if (locale === "de") return de_typing_u3_faq3_a(inputs)
	if (locale === "nl") return nl_typing_u3_faq3_a(inputs)
	if (locale === "fr") return fr_typing_u3_faq3_a(inputs)
	if (locale === "it") return it_typing_u3_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_typing_u3_faq3_a(inputs)
	if (locale === "pt") return pt_typing_u3_faq3_a(inputs)
	if (locale === "ja") return ja_typing_u3_faq3_a(inputs)
	return zh_typing_u3_faq3_a(inputs)
};